import { useTranslation } from 'react-i18next'
import Sections from 'components/Contractors/sections'
import { ReadOnlyTextField } from 'components/Shared/ReadOnlyTextField'
import { ReadOnlyCheckbox } from 'components/Shared/ReadOnlyCheckbox'
import { DetailsColumn } from 'components/Shared/CrudComponents'
import React, {useState} from 'react'
import {
  CONTRACTOR_COST_PAYMENT_DUE_DATE_READ, CONTRACTOR_CURRENCY_READ,
  CONTRACTOR_DEBT_LIMIT_READ,
  CONTRACTOR_INCOME_PAYMENT_DUE_DATE_READ,
  useAuth,
} from 'context/auth'
import {PrimaryButton} from "../../Shared/PrimaryButton";
import {
  ContractorVerificationRequestDialog
} from "../../Shared/Dialogs/ContractorVerificationRequestDialog/ContractorVerificationRequestDialog";

export const ContractorAdditionalDetails = ({ contractor, previousContractor, ...columnProps }) => {
  const { t } = useTranslation()
  const { hasAnyPrivileges } = useAuth()
  const [verificationRequestDialogOpen, setVerificationRequestDialogOpen] = useState(false)

  return (
    <DetailsColumn section={Sections.AdditionalDetails} {...columnProps}>
      <ReadOnlyTextField label={'contractor.form.additionalInfo'}
                         value={contractor.additionalInfo}
                         previousValue={previousContractor && { value: previousContractor.additionalInfo }} />
      {hasAnyPrivileges([CONTRACTOR_INCOME_PAYMENT_DUE_DATE_READ]) &&
        <ReadOnlyTextField label={'contractor.form.incomePaymentDueDays'}
                           value={contractor.incomePaymentDueDays}
                           previousValue={previousContractor && { value: previousContractor.incomePaymentDueDays }} />
      }
      {hasAnyPrivileges([CONTRACTOR_COST_PAYMENT_DUE_DATE_READ]) &&
        <ReadOnlyTextField label={'contractor.form.costPaymentDueDays'}
                           value={contractor.costPaymentDueDays}
                           previousValue={previousContractor && { value: previousContractor.costPaymentDueDays }} />
      }
      {hasAnyPrivileges([CONTRACTOR_DEBT_LIMIT_READ]) &&
        <ReadOnlyTextField label={'contractor.form.debtLimit'}
                           value={contractor.debtLimit}
                           previousValue={previousContractor && { value: previousContractor.debtLimit }} />
      }
      {hasAnyPrivileges([CONTRACTOR_CURRENCY_READ]) &&
        <ReadOnlyTextField label={'contractor.form.currency'}
                           value={contractor.currency}
                           previousValue={previousContractor && { value: previousContractor.currency }} />
      }
      <ReadOnlyTextField label={'contractor.form.hvExpirationDate'} asDateTime
                         value={contractor.hvExpirationDate}
                         previousValue={previousContractor && { value: previousContractor.hvExpirationDate }}
      />

      <ReadOnlyTextField label={'contractor.form.carrierVerificationExpirationDate'} asDateTime
                         value={contractor.carrierVerificationExpirationDate}
                         previousValue={previousContractor && { value: previousContractor.carrierVerificationExpirationDate }}
      />
      <PrimaryButton
        type="button"
        label={t('contractorVerification.requestButton')}
        onClick={()=>setVerificationRequestDialogOpen(true)}
        className={'in-form-control-button'}
      />
      <ReadOnlyCheckbox
        checked={contractor.eInvoiceConsent}
        diffValue={previousContractor?.eInvoiceConsent}
        label={t('contractor.form.eInvoiceConsent')} />
      <ReadOnlyCheckbox
        checked={contractor.isPartnershipSubsidiary}
        diffValue={previousContractor?.isPartnershipSubsidiary}
        label={t('contractor.form.isPartnershipSubsidiary')} />
      <ReadOnlyCheckbox
        checked={!!contractor.requireCarrierVerifiedHV}
        diffValue={previousContractor?.requireCarrierVerifiedHV}
        label={t('contractor.form.requireCarrierVerifiedHV')} />
      <ReadOnlyCheckbox
        checked={!!contractor.requireCarrierVerifiedBasic}
        diffValue={previousContractor?.requireCarrierVerifiedBasic}
        label={t('contractor.form.requireCarrierVerifiedBasic')} />
      <ContractorVerificationRequestDialog open={verificationRequestDialogOpen}
                                           contractorId={contractor.id}
                                           onClose={() => {
                                             setVerificationRequestDialogOpen(false)
                                           }}
      />
    </DetailsColumn>
  )
}
